import {useQuery} from 'react-query';
import {client} from './ApiClient';
import {mapServiceUrls} from '../Helpers/Functions';
import {SnippetAuth} from './SnippetAuth';

// The Loyalty Engine returns the eGift lines of the snippet's cart; pick the line by LineUid, else the first line for
// the product.
const getEGiftCartLine = async (urls: any, auth: SnippetAuth, lineUid: string, productCode: string) => {
	const response = await client(urls.LoyaltyEngineApiUrl, 'v5/snippets/carts/egiftcards', {...auth});
	const lines: Array<any> = response?.data?.Lines ?? []
	return (lineUid ? lines.find(l => l.Uid === lineUid) : undefined)
		?? (productCode ? lines.find(l => l.ProductCode === productCode) : undefined)
		?? null
}

// eGiftLine is undefined until loaded, then the snippet cart's eGift line or null when it has none.
export default function useGetEGiftCartLine(urls: any, auth: SnippetAuth | undefined, lineUid: string, productCode: string) {
	const {status, data, error} = useQuery(['EGiftCartLine', auth?.apiKey, lineUid, productCode],
		() => getEGiftCartLine(mapServiceUrls(urls), auth as SnippetAuth, lineUid, productCode),
		{ enabled: urls && !!auth, staleTime: 1000*60*60 });
	const eGiftLine = data === undefined ? undefined : data;
	return {lineStatus: status, eGiftLine, lineError: error};
}
